module.exports = __webpack_public_path__ + "img/images_project_bg1.6f8f49b6.png";